module.exports = {
  social_deduction_games_online: {
    title: '在线社交推理游戏：5–10 人好友局比较',
    description: '比较阿瓦隆、狼人杀与 Secret Hitler 的人数、淘汰和开局条件，选择好友局或机器人练习。',
    keywords: ['在线社交推理游戏'],
    breadcrumbs: [
      {
        to: '/zh-cn/',
        title: '首页',
      },
      {
        to: '/zh-cn/guides/social-deduction-games-online/',
        title: '在线社交推理游戏',
      },
    ],
  },
  games_like_secret_hitler: {
    title: '类似 Secret Hitler 的游戏：阿瓦隆对比',
    description: '比较投票、任务与梅林刺杀，了解 5–10 人好友局或单人机器人练习怎么开始。',
    keywords: ['类似 Secret Hitler 的游戏'],
    breadcrumbs: [
      {
        to: '/zh-cn/',
        title: '首页',
      },
      {
        to: '/zh-cn/guides/social-deduction-games-online/',
        title: '在线社交推理游戏',
      },
      {
        to: '/zh-cn/guides/games-like-secret-hitler/',
        title: '类似 Secret Hitler 的游戏',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: '阿瓦隆和狼人杀的区别：淘汰与投票',
    description: '比较阿瓦隆、狼人杀与杀人游戏的淘汰、角色和任务投票，了解持续参与的玩法与在线开局方式。',
    keywords: ['阿瓦隆和狼人杀的区别'],
    breadcrumbs: [
      {
        to: '/zh-cn/',
        title: '首页',
      },
      {
        to: '/zh-cn/guides/social-deduction-games-online/',
        title: '在线社交推理游戏',
      },
      {
        to: '/zh-cn/guides/avalon-vs-werewolf/',
        title: '阿瓦隆与狼人杀对比',
      },
    ],
  },
};
